


import AnHuiIndex from '@/views/study/AnHui/index'



export default {
  path: '/study',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
      {
        path: 'AnHui/index',
        name: 'AnHuiIndex',
        component: AnHuiIndex
      },


  ],
};
